import { render } from "./CubeCSS.vue?vue&type=template&id=6fdaa934&scoped=true&ts=true"
import script from "./CubeCSS.vue?vue&type=script&lang=ts"
export * from "./CubeCSS.vue?vue&type=script&lang=ts"

import "./CubeCSS.vue?vue&type=style&index=0&id=6fdaa934&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdaa934"]])

export default __exports__